














































import { listFactory } from '@/main/pages';
import { deleteButton } from '@/main/utils/tableOperations';

import { store } from './store/list';
import { NAME, TYP_UCETNI_UZAVERKA } from './constants';
import { apiProvider } from './api';

export default listFactory(NAME, store).extend({
	data() {
		return {
			typ: 0,
			TYP_UCETNI_UZAVERKA,
			extraButtons: {
				...deleteButton((e: any, cells: any) => this.deleteItem(cells[this.table!.cellNames!.idColumn])),
			},
		};
	},
	computed: {
		uzaverkaUcetniFilter(): object {
			return {
				TypId: this.typ,
				DoKdy: this.DoKdy,
				PracovnikId: this.PracovnikId,
				ProvozovnaId: this.ProvozovnaId,
			};
		},
	},
	methods: {
		async uzaverka() {
			this.startLoading();
			if (this.MakeServis) {
				this.typ = this.TypId === TYP_UCETNI_UZAVERKA.PRUBEZNA ? 1 : 2;
				await apiProvider.uzaverkaUcetni(this.uzaverkaUcetniFilter);
			}
			if (this.MakeNV) {
				this.typ = this.TypId === TYP_UCETNI_UZAVERKA.PRUBEZNA ? 3 : 4;
				await apiProvider.uzaverkaUcetni(this.uzaverkaUcetniFilter);
			}
			if (this.MakeOV) {
				this.typ = this.TypId === TYP_UCETNI_UZAVERKA.PRUBEZNA ? 5 : 6;
				await apiProvider.uzaverkaUcetni(this.uzaverkaUcetniFilter);
			}
			this.endLoading();
		},
	},
});
